import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CATEGORY_LABELS = {
  totalSourced: 'Profiles sourced',
  totalSubmitted: 'Submitted',
  totalJoined: 'Joined',
  inPipeline: 'In pipeline',
  beelineSourced: 'Beeline sourced',
  directSourced: 'Direct sourced',
  beelineJoined: 'Beeline joined',
  beelineSubmissions: 'Portal submissions',
};

export default function CandidateListView({ category, month, week, onBack }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  setLoading(true);
  axios
    .get(`${API_BASE}/api/analytics/candidates`, { params: { category, month, week } })
    .then((res) => setRows(res.data.rows))
    .catch((err) => console.error('Error fetching candidates:', err))
    .finally(() => setLoading(false));
}, [category, month, week]);

  return (
    <div className="analytics-page">
      <button className="btn-outline" onClick={onBack} style={{ marginBottom: 16 }}>
        <ArrowLeft size={16} /> Back to dashboard
      </button>

      <h2>{CATEGORY_LABELS[category] || category} ({rows.length})</h2>

      <div className="content-card" style={{ padding: '4px 0' }}>
        <div className="table-container">
          <table className="modern-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Job</th>
                <th>Recruiter</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24 }}>Loading…</td></tr>
              )}
              {!loading && rows.length === 0 && (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: '#94a3b8' }}>No candidates found</td></tr>
              )}
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.name}</td>
                  <td>{r.email}</td>
                  <td>{r.phone || '—'}</td>
                  <td>{r.status}</td>
                  <td>{r.job || '—'}</td>
                  <td>{r.recruiter || '—'}</td>
                  <td>{new Date(r.submittedAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}